import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  return _openBlock(), _createBlock(_component_b_row, {
    class: "h-100 w-100",
    "align-h": "center"
  }, {
    default: _withCtx(() => [_createVNode(_component_b_col, {
      class: "text-center h-100 w-100 mx-auto",
      "g-0": "",
      "align-self": "center"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createElementVNode("a", {
        href: "//sbnbroadcasting.com/"
      }, [_createElementVNode("img", {
        src: "/img/inactive.png",
        alt: "Network Disabled",
        style: {
          "height": "100vh"
        }
      })], -1)]))], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  });
}